import React from "react";
import { RxCross2 } from "react-icons/rx";
import { useMyContext } from "../MyContext";

export default function DownloadDataModal({ closeModal, workbookData, sheetId }) {
  console.log(sheetId);
  // const handleDownloadSheet = (sheetID) => {
  //   console.log("Download Sheet ID:", sheetID);
  //   // Add functionality to download this specific sheet here.
  // };

  const { callFunction } = useMyContext();
  const dashboardSheetObject = workbookData.sheets.find(obj => obj.ID === sheetId);
  const sheetsVisibleOnDashboardArray = dashboardSheetObject.SheetsArray
  console.log(sheetsVisibleOnDashboardArray);


  return (
    <main className="fixed inset-0 bg-black bg-opacity-50 flex flex-col items-center justify-center z-10">
      <main className="bg-white w-80 h-[18rem] border rounded shadow-lg items-center justify-between flex flex-col">
        {/* header */}
        <header className="w-full h-[10%] flex items-center justify-between p-1 bg-gray-100">
          Download Data
          <RxCross2
            onClick={closeModal}
            className="cursor-pointer text-gray-600 hover:text-black"
          />
        </header>

        {/* body */}
        <div className="w-full h-[75%] p-1 items-start justify-start overflow-hidden overflow-y-auto">
          {sheetsVisibleOnDashboardArray.map((sheet) =>

            <div key={sheet.Sheetid} className="flex justify-between items-center mb-[6px]">
              <span>{sheet.SheetName}</span>
              <button
                onClick={() => callFunction(sheet.Sheetid)}
                className="text-sm px-2 py-[2px] bg-blue-950 text-white rounded"
              >
                Download
              </button>
            </div>

          )}
        </div>

        {/* footer */}
        <footer className="w-full h-[15%] p-1 flex justify-end">
          <button
            onClick={closeModal}
            className="px-3 py-1 border text-black tracking-wide rounded-md"
          >
            Close
          </button>
        </footer>
      </main>
    </main>
  );
}
